// extracted by mini-css-extract-plugin
module.exports = {"trailer":"h1","imgWrapper":"h2","thumbnail":"h3","isRental":"h4","playWrapper":"h5","playImg":"h6","title":"h7","iconWrapper":"h8","navArrow":"h9"};